export default "__VITE_ASSET__4997f3b2__"